import BarekamText from "../../../../../pages/components/text";
import {Message, MessageSections} from "../../../../../pages/components/message/message";
import React from "react";

const EmptyScanPopup = () => {
    return (
        <div style={{paddingTop: '3rem', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column'}}>
            <BarekamText variant={"m"}>
                <Message messageKey={"scan_to_continue"} sectionId={MessageSections.ORDERS}/>
            </BarekamText>
        </div>
    )
}

export default EmptyScanPopup;